module.exports = __webpack_public_path__ + "static/media/Slice5.ba87c76c.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_151/img/Slice5.png
// module id = 1486
// module chunks = 0